var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"checkbox",attrs:{"type":"checkbox","name":_vm.id},domProps:{"value":_vm.value}}),_c('label',[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }